import React from 'react'
import { Avatar } from 'antd'
import { subStringAvatar } from '../common/CellText'

import { apiUrl } from '../../config'
import utils from './../../utils'

export const AvatarHasName = props => {
  const { imgId, name, justifyContent, position, icon, size } = props

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: justifyContent || 'flex-start',
        alignItems: 'center',
      }}>
      <Avatar
        size={size || 28}
        style={{ backgroundColor: '#2C65AC', fontSize: 12 }}
        src={imgId && `${apiUrl}/api/v1/images/${imgId}`}>
        {icon ? (
          <div
            className="mt-[7px]"
            style={{
              position: 'absolute',
              transform: 'translate(-50%, -15%)',
            }}>
            {icon}
          </div>
        ) : (
          <div>{subStringAvatar(name)}</div>
        )}
      </Avatar>
      <div
        style={{
          fontWeight: 600,
          marginLeft: 5,
          display: 'flex',
          flexDirection: 'row',
        }}>
        <span>{utils.getNameInCapitalize(name)}</span>
        {position && (
          <i style={{ fontWeight: 400, marginLeft: 4 }}>({position})</i>
        )}
      </div>
    </div>
  )
}
